<template>
  <div @click="download">
    <slot></slot>
  </div>
</template>

<script>
import { getTournamentNumber } from '@/lib/utils'
export default {
  props: {
    downloadOldData: { type: Boolean, default: false },
    filename: { type: String, default: 'numerai_datasets.zip' },
  },
  methods: {
    async download() {
      const link = document.createElement('a')
      link.download = this.filename
      if (this.downloadOldData) {
        link.href = await this.$client.getOldDataset()
      } else {
        link.href = await this.$client.getDataset(
          this.filename,
          getTournamentNumber(),
        )
      }
      link.style.cssText = 'display:none;'
      // add link to dom because firefox doesn't allow cross origin non dom
      // browser download triggers
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
  },
}
</script>
